import { useQueries } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import {
  filtrosDaAtencao,
  serieDoGraficoDaV2,
} from "../pages/revenue/graficoDaV2";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useRevenueChartV2({
  branchId,
  start,
  end,
  periodo,
  filtros,
  enabled = true,
}) {
  const { getRevenueMetrics, getConversionMetrics, getAttentionMetrics } =
    useApiV2();
  const { user } = useAuth();
  const ativo = Boolean(enabled && branchId && start && end && periodo);
  const base = { branch_id: branchId, start, end, group_by: periodo };
  const chave = [user?.user_id ?? null, branchId, start, end, periodo];

  const consulta = (nome, buscar, params) => ({
    queryKey: ["revenueChartV2", nome, ...chave, params],
    queryFn: () => buscar(params),
    enabled: ativo,
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });

  const consultas = useQueries({
    queries: [
      consulta("receita", getRevenueMetrics, {
        ...base,
        ...filtros,
        tipo: "presencial",
      }),
      consulta("conversao", getConversionMetrics, {
        ...base,
        tipo: "presencial",
      }),
      consulta("atencao", getAttentionMetrics, {
        ...base,
        ...filtrosDaAtencao(filtros),
      }),
    ],
  });
  const [receita, conversao, atencao] = consultas;
  const comErro = consultas.find((item) => item.isError);
  const prontas = consultas.every((item) => item.data);

  return {
    data: prontas
      ? serieDoGraficoDaV2({
          receita: receita.data,
          conversao: conversao.data,
          atencao: atencao.data,
        })
      : undefined,
    isLoading: ativo && !prontas && !comErro,
    error: comErro?.error ?? null,
  };
}
